import * as React from "react"

function PreviewIcon(props) {
    return (
        <svg width={36} height={38} viewBox="0 0 36 38" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path fillRule="evenodd" clipRule="evenodd" d="M18.3461 27.9172C14.0846 27.8962 10.6728 24.4895 10.6945 20.2781C10.7153 16.0659 14.1618 12.6936 18.4233 12.7146C22.6844 12.7355 26.0962 16.1418 26.0745 20.3541C26.0537 24.5659 22.6072 27.9386 18.3461 27.9172ZM18.4346 10.3755C12.8951 10.3483 8.35572 14.7901 8.32771 20.2661C8.3119 23.412 9.78737 26.2342 12.0968 28.069L6.65527 36.594L8.54682 37.9998C8.59561 38.0364 14.1054 29.3033 14.1054 29.3033C15.3915 29.9052 16.8209 30.2491 18.3343 30.2562C23.8739 30.2839 28.4133 25.8421 28.4413 20.3657C28.4688 14.8897 23.9751 10.4032 18.4346 10.3755Z" fill="black" />
            <path fillRule="evenodd" clipRule="evenodd" d="M34 32.7782L2 32.6567V2H25.795L34 9.50152V32.7782Z" stroke="black" strokeWidth="2.624" />
            <path d="M25.7949 2.00009V9.50117H33.9999" stroke="black" strokeWidth="2.624" />
        </svg>
    )
}

export default PreviewIcon
